import "./layout.css";
import { rectangle1, rectangle2, rectangle3 } from "../assets";
import { ReactComponent as Logo } from "../assets/autoloads-logo-black.svg";
import { Outlet, useNavigate } from "react-router-dom";



export default function Layout() {

  const navigate = useNavigate();

  const handleLogoClick = () => {
    navigate("/"); // Adjust the path as needed
  };

  return (
    <main className="layout">
      <section className="main">
        <div className="autoloadLogo" onClick={handleLogoClick}>
          <Logo className="logo" />
        </div>
        <br />
        <Outlet/>
      </section>

      <section className="hero">
        <div className="title">
          <div className="heading">Move vehicles</div>
          <div className="heading">from one place to</div>
          <div className="heading">another</div>
        </div>
        <br />
        <p>
          Providing advanced automated processes designed to streamline and
          <br /> optimize the movement of vehicles
        </p>
        <br />
        <div className="img-container">
          <img src={rectangle1} alt="Rectangle 1" />
          <img src={rectangle2} alt="Rectangle 2" />
          <img src={rectangle3} alt="Rectangle 3" />
        </div>
      </section>
    </main>
  );
}
